/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { buildGetRequest } from "../../utils/Requests";

import { ServiceLocationWithWorkOrders } from "../../utils/Interfaces";

export function getServiceLocationDetails(siteId: number) {
    return buildGetRequest<ServiceLocationWithWorkOrders>(`/api/sites/details/1/${siteId}`);
}

// export function updateWorkSite(
//     siteId: number,
//     dispatch: Dispatch<AnyAction>,
//     setSite: Setter<Site>,
//     setWorkOrders: Setter<ExpandedWorkOrder[]>,
//     setLoading: Setter<boolean>
// ) {
//     getHandler<WorkSiteDetailsResponse>(
//         `/api/sites/details/1/${siteId}`,
//         dispatch,
//         (response: AxiosResponse<WorkSiteDetailsResponse, any>) => {
//             setSite(response.data.site);
//             setWorkOrders(response.data.work_orders);
//         },
//         stdErrHandlerFactory(dispatch),
//         setLoading
//     )
// }
